import React, { useState, useEffect } from 'react';
import './CabFilters.css';
import { FaChevronDown } from "react-icons/fa";
import { Button, Col } from "react-bootstrap";
import Slider from "rc-slider";

const CabFilters = ({ applyFilters, priceLimits, cabData }) => {
  const [isCabTypeOpen, setIsCabTypeOpen] = useState(true);
  const [isSeatersOpen, setIsSeatersOpen] = useState(true);
  const [priceRange, setPriceRange] = useState([1000, 5000]);
  const [selectedCabTypes, setSelectedCabTypes] = useState([]);
  const [selectedSeaters, setSelectedSeaters] = useState([]);
  const [cabType, setCabType] = useState([]);
  const [seaters, setSeaters] = useState([]);

  useEffect(() => {
    setPriceRange(priceLimits);
  }, [priceLimits]);

  // Extract cab types & seaters from API response
  useEffect(() => {
    if (cabData?.length) {
      // Extract cab types (cleaned up from `name` field)
      const types = [...new Set(cabData.map(cab => {
        // get part before AC info — e.g., "WAGONR, CELERIO"
        const match = cab.name.split("【")[0] || cab.name;
        return match.trim();
      }))];

      // Extract seaters
      const seatOptions = [...new Set(cabData.map(cab => `${cab.total_seats} seater`))];

      setCabType(types);
      setSeaters(seatOptions);
    }
  }, [cabData]);

  const handleClearFilters = () => {
    setPriceRange(priceLimits);
    setSelectedCabTypes([]);
    setSelectedSeaters([]);
    applyFilters(priceLimits, [], []);
  };

  return (
    <div>
      <Col className="filterDiv flightListPage busFilterDiv" style={{ marginBottom: "15px" }}>
        <div className="filterHead">
          <p style={{ fontWeight: "600", color: "#001f5d", fontSize: "18px", margin: "5px" }}>
            FILTER
          </p>
          <p 
            style={{ margin: "5px", cursor: "pointer", color: "#007bff" }} 
            onClick={handleClearFilters}
          >
            CLEAR ALL
          </p>
        </div>

        {/* Price Range */}
        <div className="filterDivs" style={{ minHeight: "100px" }}>
          <div className="filterSubDiv">
            <p>Price Range</p>
          </div>
          <div className="box-content">
            <div className="slider-dragable-range slider-range-price">
              <Slider
                range
                min={priceLimits[0]}
                max={priceLimits[1]}
                value={priceRange}
                onChange={(value) => {
                  setPriceRange(value);
                  applyFilters(value, selectedCabTypes, selectedSeaters);
                }}
              />
              <div className="slider-value">
                <span>₹{priceRange[0]}</span> - <span>₹{priceRange[1]}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Cab Type */}
        <div className="cabListing-boardingPointsWrap">
          <div className="cabListing-boardingPointsHeader">
            <h4>Cab Type</h4>
            <span
              className={`cabListing-boardingPointsToggle ${isCabTypeOpen ? "open" : ""}`}
              onClick={() => setIsCabTypeOpen(!isCabTypeOpen)}
            >
              <FaChevronDown />
            </span>
          </div>

          {isCabTypeOpen && (
            <div className="cabListing-boardingPointsList">
              {cabType.map((type, index) => (
                <label key={index} className="cabListing-boardingPointItem">
                  <input
                    type="checkbox"
                    checked={selectedCabTypes.includes(type)}
                    onChange={(e) => {
                      let updated = e.target.checked
                        ? [...selectedCabTypes, type]
                        : selectedCabTypes.filter(t => t !== type);
                      setSelectedCabTypes(updated);
                      applyFilters(priceRange, updated, selectedSeaters);
                    }}
                  />
                  {type}
                </label>
              ))}
            </div>
          )}
        </div>

        {/* Seaters */}
        <div className="cabListing-boardingPointsWrap">
          <div className="cabListing-boardingPointsHeader">
            <h4>Seaters</h4>
            <span
              className={`cabListing-boardingPointsToggle ${isSeatersOpen ? "open" : ""}`}
              onClick={() => setIsSeatersOpen(!isSeatersOpen)}
            >
              <FaChevronDown />
            </span>
          </div>

          {isSeatersOpen && (
            <div className="cabListing-boardingPointsList">
              {seaters.map((seat, index) => (
                <label key={index} className="cabListing-boardingPointItem">
                  <input
                    type="checkbox"
                    checked={selectedSeaters.includes(seat)}
                    onChange={(e) => {
                      let updated = e.target.checked
                        ? [...selectedSeaters, seat]
                        : selectedSeaters.filter(s => s !== seat);
                      setSelectedSeaters(updated);
                      applyFilters(priceRange, selectedCabTypes, updated);
                    }}
                  />
                  {seat}
                </label>
              ))}
            </div>
          )}
        </div>
      </Col>
    </div>
  );
};

export default CabFilters;
